import { createReducer, on } from '@ngrx/store';

import * as packageActions from '@packages/packages-result/store/actions/packages-result.actions';
import * as hotelActions from '@hotels/hotel-results/store/actions/hotels.actions';

import { HotelFiltersResponse } from '@shared/magic-filter-bar/entities/filter-types';
import { FilterSorter } from '@shared/filters/entities/fetch-filters.response';
import { SorterTypes } from '@shared/filters/entities/sorter-options';

export const initialState: HotelFiltersResponse = {} as HotelFiltersResponse;

export const hotelFiltersReducer = createReducer(
  initialState,
  on(hotelActions.fetchHotelFiltersSuccessAction, (state, { filters }) => ({
    ...filters, Sorters: gerSorgerByHotels(),
  })),
  on(packageActions.fetchPackageHotelsFilterSuccessAction, (state, { response }) => ({
    ...response, Sorters: gerSorgerByHotels(),
  })),
  on(
    packageActions.fetchPackageHotelsFilterAction,
    packageActions.searchPackageAction,
    () => initialState
  ),
);

function gerSorgerByHotels(): FilterSorter[] {
  return [
    {
      Label: 'PRODUCT_FILTERS.SORTER.RECOMMENDED',
      OrderCriteria: SorterTypes.Recommended,
      OrderDesc: false,
    },
    {
      Label: 'PRODUCT_FILTERS.SORTER.LOWEST_PRICE',
      OrderCriteria: SorterTypes.Price,
      OrderDesc: false,
    },
    {
      Label: 'PRODUCT_FILTERS.SORTER.HIGHEST_PRICE',
      OrderCriteria: SorterTypes.Price,
      OrderDesc: true,
    },
    {
      Label: 'PRODUCT_FILTERS.SORTER.STARS',
      OrderCriteria: SorterTypes.Category,
      OrderDesc: true,
    },
    {
      Label: 'PRODUCT_FILTERS.SORTER.DISCOUNT_PERCENTAGE',
      OrderCriteria: SorterTypes.DiscountPercentage,
      OrderDesc: true,
    }
  ];
}
